import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchCustomerRedeemedCoupons,
  SearchCustomerRedeemedCouponsVariables
} from "./types/SearchCustomerRedeemedCoupons";

export const searchCustomerRedeemedCoupons = gql`
  ${pageInfoFragment}
  query SearchCustomerRedeemedCoupons(
    $after: String
    $first: Int!
    $query: String!
    $sortBy: CouponRedemptionSortingInput
    $userId: ID
    $status: [CouponRedemptionStatusEnum]
  ) {
    search: couponRedemptions(
      after: $after
      first: $first
      filter: { search: $query, status: $status, user: $userId }
      sortBy: $sortBy
    ) {
      edges {
        node {
          id
          code
          redeemedAt
          coupon {
            code
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<
  SearchCustomerRedeemedCoupons,
  SearchCustomerRedeemedCouponsVariables
>(searchCustomerRedeemedCoupons);
